module.exports = __webpack_public_path__ + "img/common-file-warning.8816cd1e.svg";